import { get, post, apiPrefix } from './common';
const getEmployeeAchAccount = () => get(`${apiPrefix}/EmployeeAchAccount`);
const createEmployeeAchAccount = (dto) => post(`${apiPrefix}/EmployeeAchAccount`, dto);
export { getEmployeeAchAccount, createEmployeeAchAccount };
